function handleEnter(formSelector, buttonSelector) {
  document.addEventListener("DOMContentLoaded", () => {
    const forms = document.querySelectorAll(formSelector);

    forms.forEach((form) => {
      const button = form.querySelector(buttonSelector);
      if (!button) return;

      form.addEventListener("keydown", (e) => {
        if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
          e.preventDefault();
          button.click();
        }
      });
    });
  });
}

window.handleEnter = handleEnter;
